export function PlusBadge() {
  return (
    <div class="flex items-center gap-2">
      <span class="text-base font-semibold text-white">Forest</span>
      <svg
        width="47"
        height="22"
        viewBox="0 0 47 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="PLUS"
        role="img"
      >
        <g filter="url(#filter0_i_22395_90085)">
          <rect
            width="47"
            height="22"
            rx="8"
            fill="url(#paint0_linear_22395_90085)"
          />
          <rect
            x="0.75"
            y="0.75"
            width="45.5"
            height="20.5"
            rx="7.25"
            stroke="white"
            stroke-width="1.5"
          />
          <path
            d="M10.64 14.892H8.72V7.296H12.104C12.864 7.296 13.472 7.388 13.928 7.572C14.384 7.756 14.712 8.056 14.912 8.472C15.112 8.888 15.212 9.452 15.212 10.164C15.212 10.836 15.112 11.384 14.912 11.808C14.712 12.224 14.384 12.532 13.928 12.732C13.472 12.932 12.864 13.032 12.104 13.032H10.64V14.892ZM11.792 8.868H10.64V11.46H11.792C12.36 11.46 12.74 11.364 12.932 11.172C13.124 10.98 13.22 10.644 13.22 10.164C13.22 9.708 13.124 9.38 12.932 9.18C12.74 8.972 12.36 8.868 11.792 8.868ZM22.4717 13.26V14.892H16.9517V7.296H18.8717V13.26H22.4717ZM30.371 7.296V11.772C30.371 12.556 30.275 13.184 30.083 13.656C29.899 14.128 29.575 14.472 29.111 14.688C28.647 14.896 27.991 15 27.143 15C26.263 15 25.579 14.896 25.091 14.688C24.611 14.472 24.275 14.128 24.083 13.656C23.891 13.184 23.795 12.556 23.795 11.772V7.296H25.715V11.736C25.715 12.144 25.755 12.464 25.835 12.696C25.915 12.928 26.059 13.092 26.267 13.188C26.475 13.276 26.767 13.32 27.143 13.32C27.495 13.32 27.763 13.276 27.947 13.188C28.139 13.092 28.271 12.928 28.343 12.696C28.415 12.464 28.451 12.144 28.451 11.736V7.296H30.371ZM31.9786 12.936C32.3306 13.056 32.7146 13.152 33.1306 13.224C33.5546 13.288 33.9746 13.32 34.3906 13.32C34.9586 13.32 35.3786 13.296 35.6506 13.248C35.9306 13.192 36.1146 13.108 36.2026 12.996C36.2906 12.884 36.3346 12.74 36.3346 12.564C36.3346 12.412 36.3026 12.292 36.2386 12.204C36.1746 12.116 36.0506 12.048 35.8666 12C35.6826 11.944 35.4106 11.9 35.0506 11.868L34.2586 11.796C33.6666 11.74 33.1986 11.616 32.8546 11.424C32.5186 11.232 32.2786 10.976 32.1346 10.656C31.9986 10.328 31.9306 9.936 31.9306 9.48C31.9306 8.936 32.0386 8.496 32.2546 8.16C32.4786 7.824 32.8386 7.58 33.3346 7.428C33.8306 7.268 34.4906 7.188 35.3146 7.188C36.3866 7.188 37.2706 7.328 37.9666 7.608L37.9306 9.24L37.8946 9.288C37.1026 9.008 36.2746 8.868 35.4106 8.868C34.9946 8.868 34.6746 8.892 34.4506 8.94C34.2266 8.98 34.0706 9.048 33.9826 9.144C33.8946 9.24 33.8506 9.376 33.8506 9.552C33.8506 9.728 33.8786 9.86 33.9346 9.948C33.9986 10.036 34.1226 10.104 34.3066 10.152C34.4906 10.192 34.7586 10.232 35.1106 10.272L35.8666 10.356C36.5066 10.428 36.9986 10.556 37.3426 10.74C37.6866 10.924 37.9226 11.172 38.0506 11.484C38.1866 11.788 38.2546 12.16 38.2546 12.6C38.2546 13.136 38.1386 13.584 37.9066 13.944C37.6826 14.296 37.3146 14.56 36.8026 14.736C36.2906 14.912 35.6066 15 34.7506 15C34.1906 15 33.6866 14.972 33.2386 14.916C32.7906 14.852 32.3546 14.768 31.9306 14.664V12.972L31.9786 12.936Z"
            fill="white"
          />
        </g>
        <defs>
          <filter
            id="filter0_i_22395_90085"
            x="0"
            y="-3"
            width="47"
            height="25"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="-3" />
            <feGaussianBlur stdDeviation="3.85" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 0.0473821 0 0 0 0.41 0"
            />
            <feBlend
              mode="normal"
              in2="shape"
              result="effect1_innerShadow_22395_90085"
            />
          </filter>
          <linearGradient
            id="paint0_linear_22395_90085"
            x1="6.58"
            y1="-2"
            x2="37.3612"
            y2="24.6009"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#62F062" stop-opacity="0.89" />
            <stop offset="1" stop-color="#01B1E1" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  )
}
